/**
 * Reducer to manage portable p2p related state
 */

import {
  DONATION_VALIDATION_TYPES,
  CIP,
  ActionTypes as types,
} from '../constants'
import serverProps from '../utils/serverProps'

const { externalConfig, recipientData = {} } = serverProps
const {
  editableAttributes = {},
  isDonateButtonCampaigns = false,
} = recipientData

const initialState = {
  showGifting: true,
  shareAddress: true,
  hideBuyPreviewAddress: false,
  showSuccessPage: true,
  isBillSplit: false,
  isExternalPartner: false,
  ...externalConfig,
  ...recipientData,
  ...editableAttributes,
  donationValidationType: DONATION_VALIDATION_TYPES.AMOUNT_VALID,
  showNoteMaxCharLimitError: false,
  showAmountIsZeroError: false,
  donationGiftAidCheckbox: false,
  isDonateButtonCampaigns,
  cipStatus: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.EXTERNAL.RECEIVED_DATA:
      return {
        ...state,
        ...action.data.externalConfig,
        ...action.data.recipientData,
      }

    case types.EXTERNAL.RECEIVED_OPTIONS:
      return { ...state, ...action.data }

    case types.EXTERNAL.SHOW_AMOUNT_DONATION_ERROR:
      return {
        ...state,
        donationValidationType: action.data,
      }
    case types.EXTERNAL.HIDE_AMOUNT_DONATION_ERROR:
      return {
        ...state,
        donationValidationType: DONATION_VALIDATION_TYPES.AMOUNT_VALID,
      }
    case types.EXTERNAL.SHOW_NOTE_MAX_CHAR_LIMIT_ERROR:
      return {
        ...state,
        showNoteMaxCharLimitError: true,
      }
    case types.EXTERNAL.HIDE_NOTE_MAX_CHAR_LIMIT_ERROR:
      return {
        ...state,
        showNoteMaxCharLimitError: false,
      }
    case types.EXTERNAL.SHOW_AMOUNT_IS_ZERO_ERROR:
      return {
        ...state,
        showAmountIsZeroError: true,
      }

    case types.EXTERNAL.HIDE_AMOUNT_IS_ZERO_ERROR:
    case types.AMOUNT.CHANGE_AMOUNT: // Hide error message when amount changes
      return {
        ...state,
        showAmountIsZeroError: false,
      }

    case types.EXTERNAL.CHANGE_GIFTAID:
      return {
        ...state,
        donationGiftAidCheckbox: action.data,
      }

    case types.EXTERNAL.RECEIVED_EXTERNAL_PARAMS: {
      const { cipFlow } = action.data
      if (cipFlow) {
        let genericStatus = ''
        let { status = '', statusCode = '' } = action.data
        status = status && status.toUpperCase()
        statusCode = statusCode && statusCode.toUpperCase()
        if (status === CIP.FAILURE) {
          genericStatus = CIP.CIP_ERROR
        } else if (status === CIP.SUCCESS && statusCode === CIP.MANUAL_REVIEW) {
          genericStatus = CIP.MANUAL_REVIEW
        } else if (status === CIP.SUCCESS && statusCode === CIP.VERIFIED) {
          genericStatus = CIP.VERIFIED
        }
        return {
          ...state,
          cipStatus: genericStatus,
        }
      }

      return {
        ...state,
      }
    }
    case types.TRANSACTION.CLEAR_FUNDING_OPTIONS:
      return {
        ...state,
        cipStatus: '', // clear out the state for next transaction
      }

    case types.OVERPANELS.SUBTRACT_CLOSED_OVERPANEL:
      return {
        ...state,
        cipStatus: '', // clear out the state for next transaction
      }
    case types.EXTERNAL.TOGGLE_IS_BILL_SPLIT:
      const { isBillSplit = false } = action.data
      return {
        ...state,
        isBillSplit,
      }

    default:
      return state
  }
}
